<template>
  <div class="chart" :class="{ small: isSmall }">
    <strong> Moungi Bawendi kvantpunktikasvandus </strong>

    <main>
      <img
        src="https://v.postimees.ee/graafikud/2023/keemiapreemia-3/kvantpunktikasvandus.png"
        alt="🪩"
      />

      <div style="top: 0; left: 62.5%; transform: translateY(-33%)">
        Reaktsiooni stabiliseeriv gaas
      </div>
      <div style="top: 9.9%; left: 69.5%">Termomeeter</div>
      <div style="top: 73%; left: 85%">Aeg</div>
      <div style="top: 37.8%; left: 50.5%; transform: translateX(-100%)">
        Lahusti
      </div>
      <div style="top: 52.8%; left: 62%">Kristallid</div>

      <section style="top: 0; width: 44%">
        <strong>1</strong>
        <div>
          Bawendi süstis kuuma lahustisse aineid, mis moodustavad
          kaadmiumseleniidi kristale. Kogused olid sellised, et lahusti
          küllastus kristalli moodustavate ainetega selle süstenõela osta
          ümbruses.
        </div>
      </section>

      <section style="top: 32.5%; width: 40%">
        <strong>2</strong>
        <div>
          Koheselt hakkasid moodustuma kaadmiumseleniidi kristallid. Kuna
          süstitav lahus jahutas maha ka lahusti, siis kristallide moodustimine
          ka peatus. Juba moodustunud kristallid jagunesid ühtlaselt lahustisse.
        </div>
      </section>

      <section style="top: 70%; width: 49%">
        <strong>3</strong>
        <div>
          Kui Bawendi soojendas lahust, hakkasid kristallid taas kasvama. Mida
          kauem ta lahust kuumutas, seda suuremaks kasvasid naoosakestest
          kvantpunktid
        </div>
      </section>
    </main>

    <footer>
      Allikas: Johan Jarnestad/Rootsi Kuninglik Teaduste Akadeemia
    </footer>
  </div>
</template>

<style>
/*.device-phone #keemiapreemia-3 {
  margin-left: calc(var(--root-padding) * -1);
  margin-right: calc(var(--root-padding) * -1);
}*/
</style>

<style scoped>
.chart {
  font-family: GT Eesti, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  color: var(--text-color);

  font-size: 16px;
  line-height: 1;
  word-spacing: 0;

  width: 100%;
  display: flex;
  flex-direction: column;

  overflow: hidden;

  --section-background-color: #e4e9ee;

  --container-width: v-bind(containerWidth + "px");

  /*  max-width: 615px;*/
}

.small.chart,
.device-phone .chart {
  /*padding: var(--root-padding);
  border-radius: 0;*/

  font-size: 13px;
}

.dark-theme .chart {
  --section-background-color: var(--gray-darken-3);
}

.chart > strong {
  font-size: 2em;
  line-height: 1.15;
  text-wrap: balance;

  margin-bottom: 0.75em;
}

.chart.small > strong {
  font-size: 1.55em;
}

main {
  width: 100%;
  position: relative;

  display: flex;
}

main > img {
  width: 52%;
  margin-left: auto;
}

.dark-theme main > img {
  filter: invert(1) hue-rotate(180deg);
}

main > div {
  position: absolute;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;

  font-size: clamp(3px, calc(0.0175 * var(--container-width)), 99px);
  font-weight: 700;
  line-height: 1.1;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  text-align: left;
}

section {
  position: absolute;
  left: 0;

  font-size: clamp(3px, calc(0.0255 * var(--container-width)), 99px);

  display: grid;
  grid-template-columns: calc(0.024 * var(--container-width)) minmax(0, 1fr);
  gap: 1em;
}

section > strong {
  font-size: 1.55em;
  transform: translateY(-0.1em);
}

section,
footer {
  font-weight: 300;
  line-height: 1.23;
}

.dark-theme section,
.dark-theme footer {
  font-weight: 400;
}

footer {
  width: 50%;
  font-size: 0.8em;
  text-wrap: balance;
  margin-top: -2em;
}

@media (max-width: 400px) {
  footer {
    margin-top: 0;
  }
}
</style>

<script setup>
import { ref, computed, onMounted, onUnmounted, nextTick, inject } from "vue";

// container element
const containerElement = inject("containerElement");
const containerWidth = ref(0);
const isSmall = computed(() => {
  return containerWidth.value < 550;
});
const isDarkTheme = ref(false);

/**
 *
 */
function onResize() {
  containerWidth.value = containerElement.clientWidth;
}

// ***

onMounted(async () => {
  window.addEventListener("resize", onResize);
  onResize();
  nextTick(onResize);
  window.setTimeout(onResize, 1500);

  //
  const htmlElement = document.querySelector("html");
  if (htmlElement.classList.contains("dark-theme")) {
    isDarkTheme.value = true;
  }
});

onUnmounted(() => {
  window.removeEventListener("resize", onResize);
});
</script>
